import { IMapyBoxItem } from "~/interfaces";
import MyMapsDialog, { IMyMapsDialog } from "./mymaps-dialog";
import { _ } from "~/i18n";
import { createMyMapsNote } from "../mymaps/note";
import { updateMapyBoxItem } from "~/util/mapybox";

interface IMyMapsEditNote extends Pick<IMyMapsDialog, "onCancel" | "onClose"> {
	data: IMapyBoxItem;
	onSave?: (note: string) => void;
	onError?: () => void;
}

/**
 * Soucasti - folder-btn, takze nemusime udelat spesl opts. pro povoleni
 */
export default class MyMapsEditNote {
	_opts: IMyMapsEditNote;

	_dialog: MyMapsDialog;

	_note: string;

	_origNote: string;

	_noteElem: HTMLTextAreaElement;

	constructor(data: IMyMapsEditNote) {
		this._opts = {
			onSave: () => {},
			onCancel: () => {},
			onClose: () => {},
			onError: () => {},
			...data,
		};
		this._note = this._opts.data.description || "";
		this._origNote = this._note;
		this._noteElem = null;

		this._build();
	}

	open() {
		this._dialog?.open();
		this._noteElem.focus();
	}

	destroy() {
		this._dialog?.destroy();
	}

	_closeDialog(force?: boolean) {
		this._opts.onClose();
		this._dialog.close(force);
	}

	_build() {
		const dialog = new MyMapsDialog({
			titles: {
				main: [_("report.note")],
				saveBtn: _("save"),
				cancelBtn: _("cancel"),
				throwAwayTitle: _("note.throwAwayNote"),
				throwAwayConfirm: _("detail.content.review2.throwAway"),
			},
			onThrowAwayTest: () => this._checkClose(),
			onThrowAwayConfirm: () => {
				this._closeDialog(true);
			},
			onSave: () => {
				this._onSave();
			},
			onCancel: () => {
				this._opts.onCancel();
				this._closeDialog(true);
			},
		});
		const mainContent = dialog.contents[0];

		mainContent.classList.add("mymaps__editNoteDialog__mainContent");

		// poznamka
		const noteData = createMyMapsNote({
			text: this._note,
			onChange: note => {
				this._note = note;
			},
		});

		mainContent.append(noteData.container);

		this._dialog = dialog;
		this._noteElem = noteData.textarea;
	}

	async _onSave() {
		// neni zmena, zrusime
		if (this._note === this._origNote) {
			this._closeDialog(true);

			return;
		}

		this._dialog.error = "";
		this._dialog.loading = true;

		try {
			await updateMapyBoxItem(this._opts.data, {
				description: this._note,
			});
		} catch (exc) {
			this._dialog.error = _("note.noteWasEditedError");
			this._dialog.loading = false;
			this._opts.onError();

			return;
		}

		// analytika
		this._opts.onSave(this._note);
		this._closeDialog(true);
	}

	_checkClose() {
		return this._note === this._origNote;
	}
}
